import { call } from 'redux-saga/effects';

import { localStorageService } from 'services/local-storage.service';
import { JwtTokensResponse, JwtTokenType } from 'store/auth/types';

export function* setupNewTokens({ accessToken, refreshToken }: JwtTokensResponse) {
  yield call([localStorageService, localStorageService.setItem], JwtTokenType.ACCESS_TOKEN, accessToken);
  yield call([localStorageService, localStorageService.setItem], JwtTokenType.REFRESH_TOKEN, refreshToken);
}
